<template>
    <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    @open="initDialog"
    width="420px">
    <el-rate
    v-model="value"
    show-text>
    </el-rate>
    <el-input style="margin-top: 3rem;" v-model="input" type="textarea" placeholder="请写下你的评价"></el-input>
    <div slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button style="margin-left: 3.5rem;" type="primary" @click="userEvaluate">确 定</el-button>
  </div>
    </el-dialog>
</template>

<script>
import {UserEvaluate} from '@/api/evaluate';
    export default {
        data(){
            return{
                dialogVisible:false,
                value:0,
                input:''
            }
        },
        methods:{
            /**初始化弹窗数据 */
            initDialog(){
                this.value=0;
                this.input='';
            },
           /**用户评价 */
            userEvaluate(){
                    var params=[{
                        "businessId": this.$route.query.id,
                        "businessType": "resource",
                        "evaluateContent": this.input,
                        "evaluateScore": this.value,
                        "evaluateType": "general"
                        }]
                    UserEvaluate(params).then(res=>{
                        if(res.code==200){
                            this.$msg({
                                    showClose: true,
                                    message: "评价成功",
                                    type: "success",
                                });
                            this.dialogVisible=false;
                            this.$emit('evaluate_success');
                        }
                    })
        },
        }
    }
</script>

<style lang="less" scoped>
/deep/.el-dialog__header{
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    margin-top: 1rem;
}
/deep/.el-dialog__title{
    margin-top: 1rem;
}
/deep/.el-dialog__body{
    text-align: center;
}
.dialog-footer{
    text-align: center;
}
/deep/.el-rate__icon{
    font-size: 2.7rem;
}
/deep/.el-textarea__inner{
    min-height: 9rem !important;
}
/deep/.el-dialog{
    border-radius: 1rem;
}
</style>